"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _NJNW7W5Mcjs = require('../__chunks/NJNW7W5M.cjs');
require('../__chunks/DD7MF4PQ.cjs');
require('../__chunks/XRATBFDX.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-group-label.tsx
var TagName = "div";
var useComboboxGroupLabel = _PTOCUU2Dcjs.createHook.call(void 0, function useComboboxGroupLabel2(props) {
  props = _NJNW7W5Mcjs.useCompositeGroupLabel.call(void 0, props);
  return props;
});
var ComboboxGroupLabel = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxGroupLabel2(props) {
  const htmlProps = useComboboxGroupLabel(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ComboboxGroupLabel = ComboboxGroupLabel; exports.useComboboxGroupLabel = useComboboxGroupLabel;
